<div
  *ngIf="observation"
  class="ir-area ir-mask th-mask"
  [open]="!isOpen"
  [attr.data-keyboard]="true"
  [attr.data-backdrop]="false"
>
  <div class="ir-modal th-modal">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line--right">
          <div class="ir-btn th-btn-modal" (click)="openMenu()">
            <i class="material-icons">more_vert</i>
          </div>
        </div>
        <div class="ir-line-content">
          <span>{{ 'common.edit' | translate }} {{ 'plugins.observation.name' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table" style="width: auto; margin-bottom: 4em">
          <tr class="th-plugin-line--checkbox label" (click)="updateObservationSelection()">
            <td>
              <i class="material-icons" *ngIf="!isSelectedObservation()">check_box_outline_blank</i>
              <i class="material-icons important" *ngIf="isSelectedObservation()">check_box</i>
              <span>{{ 'plugins.observation.active-this' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input">
            <td colspan="2">
              <span
                innerHtml="<strong>{{ 'plugins.observation.name' | translate }} :</strong> {{
                  observation.Observation
                }}"
              ></span>
            </td>
          </tr>
          <tr class="th-plugin-line--input" *ngIf="isSelectedObservation()">
            <td colspan="2">
              <span
                innerHtml="<strong>{{ 'plugins.observation.recommandation' | translate }} :</strong> {{
                  observation.Recommandation
                }}"
              ></span>
            </td>
          </tr>
        </table>
        <!-- Productivity -->

        <table class="ir-plugin-table" *ngIf="isSelectedObservation()">
          <tr class="th-plugin-line--input">
            <td colspan="2">
              <span>{{ 'plugins.observation.impact' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--header th-plugin-line--checkbox label" (click)="updateProductivitySelection()">
            <td colspan="2">
              <i class="material-icons" *ngIf="!isCheckedProductivity()">check_box_outline_blank</i>
              <i class="material-icons" *ngIf="isCheckedProductivity()">check_box</i>
              <span>{{ 'plugins.observation.productivity' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input" *ngIf="isCheckedProductivity()">
            <td style="width: 50%">
              <span>{{ 'plugins.observation.additional-sheets' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  type="text"
                  [(ngModel)]="observation.Impact.TextProductivity"
                  placeholder=""
                  class="ir-form-set"
                />
              </div>
            </td>
          </tr>
        </table>
        <!-- Set up -->
        <table class="ir-plugin-table" *ngIf="isSelectedObservation()">
          <tr class="th-plugin-line--header th-plugin-line--checkbox label" (click)="updateSetupSelection()">
            <td colspan="2">
              <i class="material-icons" *ngIf="!isCheckedSetup()">check_box_outline_blank</i>
              <i class="material-icons" *ngIf="isCheckedSetup()">check_box</i>
              <span>{{ 'plugins.observation.set-up' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input" *ngIf="isCheckedSetup()">
            <td style="width: 50%">
              <span>{{ 'plugins.observation.minutes-saved' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input type="text" [(ngModel)]="observation.Impact.TextSetup" placeholder="" class="ir-form-set" />
              </div>
            </td>
          </tr>
        </table>
        <!-- Safety -->
        <table class="ir-plugin-table" *ngIf="isSelectedObservation()">
          <tr class="th-plugin-line--header th-plugin-line--checkbox label" (click)="updateSafetySelection()">
            <td colspan="2">
              <i class="material-icons" *ngIf="!isCheckedSafety()">check_box_outline_blank</i>
              <i class="material-icons" *ngIf="isCheckedSafety()">check_box</i>
              <span>{{ 'plugins.observation.safety' | translate }}</span>
            </td>
          </tr>
        </table>
        <!-- Quality -->
        <table class="ir-plugin-table" *ngIf="isSelectedObservation()">
          <tr class="th-plugin-line--header th-plugin-line--checkbox label" (click)="updateQualitySelection()">
            <td colspan="2">
              <i class="material-icons" *ngIf="!isCheckedQuality()">check_box_outline_blank</i>
              <i class="material-icons" *ngIf="isCheckedQuality()">check_box</i>
              <span>{{ 'plugins.observation.quality' | translate }}</span>
            </td>
          </tr>
        </table>
        <!-- Availability -->
        <table class="ir-plugin-table" *ngIf="isSelectedObservation()">
          <tr class="th-plugin-line--header th-plugin-line--checkbox label" (click)="updateAvailabilitySelection()">
            <td colspan="2">
              <i class="material-icons" *ngIf="!isCheckedAvailability()">check_box_outline_blank</i>
              <i class="material-icons" *ngIf="isCheckedAvailability()">check_box</i>
              <span>{{ 'plugins.observation.availability' | translate }}</span>
            </td>
          </tr>
          <tr class="th-plugin-line--input" *ngIf="isCheckedAvailability()">
            <td style="width: 50%">
              <span>{{ 'plugins.observation.minutes-saved-perDay' | translate }}</span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  type="text"
                  [(ngModel)]="observation.Impact.TextAvailability"
                  placeholder=""
                  class="ir-form-set"
                />
              </div>
            </td>
          </tr>
        </table>
        <!--Responsible-->
        <table class="ir-plugin-table" *ngIf="isSelectedObservation()">
          <tr class="th-plugin-line--checkbox label">
            <td class="margin-big" style="width: 50%">
              <h2>
                <span>{{ 'plugins.observation.to-take-action' | translate }}</span>
              </h2>
            </td>
            <td *ngFor="let resp of responsibles; let last = last" [ngStyle]="{ width: last ? '29%' : '' }">
              <div class="ir-item-line clickable indent nobreak" (click)="changeResponsible(resp)">
                <div class="ir-item-cell">
                  <div class="ir-item-selector">
                    <i class="material-icons" *ngIf="!isResponsible(resp)">radio_button_unchecked</i>
                    <i class="material-icons important" *ngIf="isResponsible(resp)">radio_button_checked</i>
                  </div>
                  <span>{{ resp.value | responsiblespipe }}</span>
                </div>
              </div>
            </td>
          </tr>
          <!--Priority-->
          <tr class="th-plugin-line--checkbox label">
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.observation.priority' | translate }}</span>
              </h2>
            </td>
            <td *ngFor="let prio of priorities; let last = last">
              <div class="ir-item-line clickable indent nobreak" (click)="changePriority(prio)">
                <div class="ir-item-cell">
                  <div class="ir-item-selector">
                    <i class="material-icons" *ngIf="!isPriority(prio)">radio_button_unchecked</i>
                    <i class="material-icons important" *ngIf="isPriority(prio)">radio_button_checked</i>
                  </div>
                  <span>{{ prio.value | prioritiespipe }}</span>
                </div>
              </div>
            </td>
          </tr>
          <tr class="th-plugin-line--checkbox label" *ngIf="isSelectedObservation()" (click)="updateIsInActionPlan()">
            <td></td>
            <td colspan="3" class="include-action-plan">
              <i class="material-icons" *ngIf="!isInActionPlan()">check_box_outline_blank</i>
              <i class="material-icons important" *ngIf="isInActionPlan()">check_box</i>
              <span>Include in action plan</span>
            </td>
          </tr>
        </table>
        <!--Machines-->
        <table class="ir-plugin-table" style="margin-bottom: 4em" *ngIf="isSelectedObservation()">
          <tr class="th-plugin-line--input">
            <td colspan="2">
              <span>{{ 'plugins.observation.machines' | translate }}* </span
              ><span class="th-txt--error">{{ 'plugins.observation.machines-required' | translate }}</span>
            </td>
          </tr>
          <tr
            *ngFor="let m of getMachines(); let i = index"
            class="th-plugin-line--header th-plugin-line--checkbox label"
            (click)="updateMachineSelection(i)"
          >
            <td colspan="2">
              <i class="material-icons" *ngIf="!isSelectedMachine(i)">check_box_outline_blank</i>
              <i class="material-icons" *ngIf="isSelectedMachine(i)">check_box</i>
              <span *ngIf="!m.CustomerEquipementId">{{ m.name }}</span>
              <span *ngIf="m.CustomerEquipementId">{{ m.name }} ({{ m.CustomerEquipementId }})</span>
            </td>
          </tr>
          <tr
            *ngIf="unitedMachines && unitedMachines.length"
            class="th-plugin-line--header th-plugin-line--checkbox label"
            (click)="updateAllMachines()"
          >
            <td>
              <i class="material-icons" *ngIf="!isAllMachines">check_box_outline_blank</i>
              <i class="material-icons" *ngIf="isAllMachines">check_box</i>
              <span>{{ 'plugins.observation.all-machines' | translate }}</span>
            </td>
          </tr>
        </table>
        <!--Time to repair-->
        <ng-container *ngIf="isSelectedObservation()">
          <h2>
            <span>{{ 'plugins.time-to-repair.repair-will-take' | translate }} :</span>
          </h2>
          <table class="ir-plugin-table" *ngIf="isSelectedObservation()" style="margin-bottom: 4em">
            <tr class="th-plugin-line--subheader">
              <td style="width: 20%">
                <span>{{ 'plugins.time-to-repair.hours' | translate }}</span>
              </td>
              <td style="width: 20%">
                <span>{{ 'plugins.time-to-repair.minutes' | translate }}</span>
              </td>
              <td colspan="2" style="width: 60%">
                <span>{{ 'plugins.time-to-repair.perfomed-by' | translate }} :</span>
              </td>
            </tr>
            <tr class="th-plugin-line--input" *ngFor="let item of observation.TimeToRepairs; let i = index">
              <td style="width: 20%">
                <div class="ir-form-group margin">
                  <input placeholder="00" class="ir-form-set" type="number" min="0" [(ngModel)]="item.Hours" />
                </div>
              </td>
              <td style="width: 20%">
                <div class="ir-form-group margin">
                  <input
                    placeholder="00"
                    class="ir-form-set"
                    type="number"
                    min="0"
                    max="59"
                    [(ngModel)]="item.Minutes"
                  />
                </div>
              </td>
              <td class="th-plugin-line--value">
                <input type="hidden" class="ir-form-set" />
                <div class="ir-line ir-select th-select" (click)="openReparatorSelector(item.Reparator, i)">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      item.Reparator || item.Reparator === 0
                        ? (item.Reparator | reparatorpipe)
                        : ('plugins.time-to-repair.select-people' | translate)
                    }}</span>
                  </div>
                </div>
              </td>
              <td class="th-plugin-line--remove">
                <i class="material-icons" (click)="remove(i)">remove_circle</i>
              </td>
            </tr>
            <tr class="th-plugin-line--add">
              <td colspan="4">
                <i class="material-icons" (click)="add()">add_circle</i>
              </td>
            </tr>
          </table>
        </ng-container>
        <!--Parts-->
        <ng-container *ngIf="isSelectedObservation()">
          <h2>
            <span>{{ 'plugins.parts.add-part' | translate }}</span>
          </h2>
          <table class="ir-plugin-table">
            <tr class="th-plugin-line--header">
              <td class="th-plugin-line--data">
                <span>N°</span>
              </td>
              <td class="th-plugin-line--data">
                <span>{{ 'plugins.parts.pages' | translate }}</span>
              </td>
              <td class="th-plugin-line--data">
                <span>{{ 'plugins.parts.position' | translate }}</span>
              </td>
              <td class="th-plugin-line--data">
                <span>{{ 'plugins.parts.parts-name' | translate }}</span>
              </td>
              <td class="th-plugin-line--data">
                <span>{{ 'plugins.parts.quantity' | translate }}</span>
              </td>
              <td class="th-plugin-line--data" colspan="2">
                <span>{{ 'plugins.parts.add-remove' | translate }}</span>
              </td>
            </tr>
            <tr class="th-plugin-line--input" *ngFor="let part of observation.Parts; let i = index">
              <td>
                <input type="text" class="ir-form-set" [(ngModel)]="part.Id" />
              </td>
              <td>
                <input type="text" class="ir-form-set" [(ngModel)]="part.Page" />
              </td>
              <td>
                <input type="text" class="ir-form-set" [(ngModel)]="part.Position" />
              </td>
              <td>
                <input type="text" class="ir-form-set" [(ngModel)]="part.PartsName" />
              </td>
              <td>
                <input type="number" class="ir-form-set" [(ngModel)]="part.Quantity" min="1" />
              </td>
              <td class="th-plugin-line--numbers">
                <i class="material-icons" *ngIf="part.Quantity > 0" (click)="updateQuantity(part, -1)">remove_circle</i>
                <i class="material-icons th-disabled" *ngIf="part.Quantity === 0">remove_circle</i>
                <i class="material-icons" (click)="updateQuantity(part, 1)">add_circle</i>
              </td>
              <td class="th-plugin-line--remove">
                <i class="material-icons" (click)="removeParts(i)">remove_circle</i>
              </td>
            </tr>
            <tr class="th-plugin-line--add">
              <td colspan="8">
                <i class="material-icons" (click)="addParts()">add_circle</i>
              </td>
            </tr>
          </table>
        </ng-container>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="close()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            (click)="save()"
            [disabled]="!isAnyMachineSelected() && isSelectedObservation()"
          >
            <span>{{ 'common.save' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<modal (modalOutput)="selectReparatorMenu($event)" #reparatorModal></modal>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deleteObservation()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>observation</strong> ?'"
  [danger]="true"
></confirm>
<add-observation
  [title]="'Edit observation content'"
  #addObservation
  (toggleSave)="saveEditObservation()"
  (toggleCancel)="cancel()"
></add-observation>
